//#region src/wayfinder_link_type.ts
let WayfinderLinkType = /* @__PURE__ */ function(WayfinderLinkType) {
	WayfinderLinkType["Section"] = "section";
	WayfinderLinkType["Page"] = "page";
	WayfinderLinkType["Item"] = "item";
	WayfinderLinkType["None"] = "none";
	return WayfinderLinkType;
}({});
//#endregion
export { WayfinderLinkType };

//# sourceMappingURL=wayfinder_link_type.js.map